import { Product } from "@spartacus/core";

export interface CustomManufacturerCampaign {
    id?:string,
    manufacturer?:string,
    name?:string,
    productCode?:string,
    productName?:string,
    validTo?:Date,
    validFrom?:Date,
    editableUntil?:Date,
    formattedValidTo?:string,
    formattedValidFrom?:string,
    formattedEditableUntil?:string,
    productEan?:string,
    supplierArticleNumber?:string,
    expired?:boolean,
    noSerialNumberCheck?:boolean,
    startedValidity?:boolean,
    tradeInProduct?:boolean,
    numberOfCombinations?:string,
    combiValue1?:Number,
    combiValue2?:Number,
    combiProducts?: Product[],
    withNotifications?:boolean,
    campaignCodeInput?: boolean,
    formattedValue?:Number
}


export interface ManufacturerCampaignSearchData {
    productCode?:string,
    manufacturerNumber?:string,
    manufacturerId?:string,
    ean?:string,
    campaignId?:string
}

export interface ManufacturerMapping {
    manufacturer?:string,
}


export interface CustomManufacturerCampaignOverview {
   responses?: CustomManufacturerCampaign[];
   manufacturerCampaignList:CustomManufacturerCampaign[],
   manufacturerMappingList:ManufacturerMapping[],
   b2bUnitId?:string
  }

export enum CustomManufacturerCampaignSortOptions {
    manufacturer,
    id,
    productCode,
    productName,
    validFrom,
    validTo,
    editableUntil,
}

export interface ManufacturerCampaignSalesNotification {
    campaignId?:string,
    productCode?:string,
    serialNr?:string,
    campaignCode?: string,
    salesDate?:Date,
    formattedSalesDate?:string,
    salesDateForDisplay?:string,
    tradeInSerialNo?:string,
    tradeInName?:string,
    pk?:string,
    combiProduct_1?: Product,
    combiProductSerialNo_1?: string,
    combiProduct_2?: Product,
    combiProductSerialNo_2?: string,
    entryStatus?: string
}

export interface ManufacturerCampaignExportData {
    campaignId?:string,
    productCodes?:string[],
    creationDateTo?:string,
    creationDateFrom?:string
}

export interface ManufacturerCampaignExportDataList {
    manufacturerCampaignExportList?:ManufacturerCampaignExportData[]
}

export interface ManufacturerCampaignResultsData {
    message?:string,
    invalidItems?:string[]
    ignoredCampaignCode?:string[]
}
